import React from "react";
import { Mail, Phone } from "lucide-react";
import Logo from "./view.logo";

export default function ViewFooter() {
    return (
        <footer className="bg-brand-950 text-white/70 pt-16 pb-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-10">
                    <div>
                        <div className="flex items-center gap-2.5">
                            <Logo size={34} />
                            <span className="text-xl font-extrabold text-white tracking-tight">Medic'help</span>
                        </div>
                        <p className="mt-4 text-sm">Simplifier l'accès aux soins de santé.</p>
                    </div>
                    <div>
                        <h4 className="text-sm font-bold text-white mb-4">Produit</h4>
                        <ul className="space-y-0.5 text-sm">
                            <li><a href="#features" className="inline-block py-2 hover:text-white transition-colors">Fonctionnalités</a></li>
                            <li><a href="#how" className="inline-block py-2 hover:text-white transition-colors">Comment ça marche</a></li>
                            <li><a href="#pricing" className="inline-block py-2 hover:text-white transition-colors">Tarifs</a></li>
                            <li><a href="#join" className="inline-block py-2 hover:text-white transition-colors">Espace médecins</a></li>
                            <li><a href="#join-cabinet" className="inline-block py-2 hover:text-white transition-colors">Espace cabinets</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-sm font-bold text-white mb-4">Entreprise</h4>
                        <ul className="space-y-0.5 text-sm">
                            <li><a href="https://savantech.org" target="_blank" rel="noopener noreferrer" className="inline-block py-2 hover:text-white transition-colors">SavanTech</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-sm font-bold text-white mb-4">Contact</h4>
                        <ul className="space-y-0.5 text-sm">
                            <li><a href="mailto:savantech25@gmail.com" className="inline-flex items-center gap-2 py-2 hover:text-white transition-colors"><Mail className="w-4 h-4" /> savantech25@gmail.com</a></li>
                            <li><a href="https://wa.me/22604894780" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 py-2 hover:text-white transition-colors"><Phone className="w-4 h-4" /> +226 04 89 47 80</a></li>
                        </ul>
                    </div>
                </div>
                <div className="mt-12 pt-8 border-t border-white/10 text-sm flex flex-col sm:flex-row justify-between gap-3">
                    <p>© {new Date().getFullYear()} Medic'help. Tous droits réservés.</p>
                    <p>Développé par <a href="https://savantech.org" target="_blank" rel="noopener noreferrer" className="font-semibold text-white hover:text-brand-200 transition-colors">SavanTech</a></p>
                </div>
            </div>
        </footer>
    );
}
